@for (section of config.sections; track section; let i = $index) {
  <section class="form-group">
    <header class="form-group__header">
      <div class="u-flex u-alignCenter u-justifyBetween u-maxX">
        <h6 class="t-bold" data-test-id="'attributeGridSectionLabel-' + i">
          {{ section.label }}
        </h6>
        @if (section.edit) {
          <i
            class="icon icon--medium icon--link"
            (click)="toggleEditModal(section)"
            data-test-id="'attributeGridSectionEditIcon-' + i"
          >
            edit
          </i>
        }
      </div>
    </header>
    <section class="employee__profile__attributes">
      @for (attribute of section.attributes; track attribute) {
        <model-attribute
          [config]="attribute"
          [context]="context"
          data-test-id="'employeeProfileAttributes-' + i"
        ></model-attribute>
      }
    </section>
  </section>
}
